import React, { useEffect, useState } from "react";
import Button, { ButtonTypes } from "../shared-components/Button";
import { useUpdateArticleRating } from "../api/ItemsApi";
import { ArticleActions, Item, ItemWithMetaData } from "../api/Items";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { useReportTimer } from "../reports/ReportDetailProvider";
import ModalWebContentForm from "./ModalWebContentForm";

type Props = {
  handleAction: (
    action: "add" | "cancel" | "completed" | "edit",
    values?: any
  ) => void;
  item: ItemWithMetaData;
  behaviors?: string[];
};

const ButtonWebcontentAdd = ({ item, handleAction, behaviors = [] }: Props) => {
  const { resetTimer } = useReportTimer();
  const { mutate: updateArticleRating, isSuccess } = useUpdateArticleRating();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      handleAction("completed");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  function performAction() {
    setIsLoading(true);
    setTimeout(() => {
      handleAction("add");
    }, 333);
  }

  function handleAdd() {
    const createdAt = item.item?.content?.created_at;
    const isValidDate = createdAt && !isNaN(new Date(createdAt).getTime());

    if (!isValidDate) {
      setShowModal(true);
    } else {
      updateArticleRating({
        item_uuid: item.item.external_id,
        article_action: ArticleActions.ADDED,
      });
      resetTimer?.();
      performAction();
    }
  }

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="hover:bg-slate-200 rounded-md">
      <Button
        id={"btn_wc_add_" + item.item.external_id}
        text={"Add Report"}
        type={ButtonTypes.add}
        onClick={handleAdd}
      />

      <ModalWebContentForm
        showModal={showModal}
        close={(updatedItem?: Item) => {
          setShowModal(false);
          if (updatedItem) {
            // After successful edit, proceed with the add action
            handleAction("edit", [updatedItem.external_id]);
            updateArticleRating({
              item_uuid: updatedItem.external_id,
              article_action: ArticleActions.ADDED,
            });
            resetTimer?.();
            performAction();
          }
        }}
        initialState={{ webContentItem: item }}
        behaviors={behaviors}
        isNew={false}
        showDateError={true}
      />
    </div>
  );
};

export default ButtonWebcontentAdd;
